import React from "react";
import { Link } from "react-router-dom";
const chartList = [
  "Madhur Morning",
  "Madhur Day",
  "Kamdhenu Day",
  "Madhur Evening	",
  "Dhanlaxmi Day",
  "Kalyan",
  "Dhanlaxmi Night",
  "Madhur Night",
  "Madhur Shubhank",
  "Kamdhenu Night",
  "Main",
  "Dhanlaxmi Morning	",
];

const RecordList = ({ type, baseRoute, gamesList }) => {
  return (
    <div className=" border-2 border-black mt-1 mb-1">
      <h2 className="uppercase pl-5 text-center bg-teal-950 text-white py-1 text-2xl lg:text-lg">
        ALL MATKA {type} CHART RECORDS
      </h2>
      <ul>
        {gamesList.map((ele) => (
          <li className="pl-5 py-1 text-blue-800 text-center ">
            <Link
              className="block min-w-full hover:underline hover:font-bold hover:text-green-700 hover:bg-green-100 text-2xl lg:text-lg"
              to={`${baseRoute}/${ele?.game_id}`}
            >
              {ele?.game_name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RecordList;
